import React from "react";

export const HTMLStringRender = ({ htmlContent }) => {
    return <div className="break-normal" dangerouslySetInnerHTML={{ __html: htmlContent }} />;
};
